import React from "react";
import NextImage from "../../common/NextImage";
import NoDataFound from "../../common/NoDataFound";
import { teamLeagueInfoUrl, titleToSlug } from "../../../utils/generalLiveCenter";

const STATS_CONFIG = {
  scorers: {
    headers: ["Players", "Pen", "G"],
    legend: [
      { symbol: "Pen", fullForm: "Penalty" },
      { symbol: "G", fullForm: "Goal Scored" },
    ],
    dataKey: "goals",
    className: "ft_player_goals",
    getRowData: (item) => [item?.mtchs, item?.gs],
  },
  assists: {
    headers: ["Players", "Pen", "A"],
    legend: [
      { symbol: "Pen", fullForm: "Penalty" },
      { symbol: "A", fullForm: "Assists" },
    ],
    dataKey: "assist",
    className: "ft_player_assist",
    getRowData: (item) => [item?.mtchs, item?.asit],
  },
  cards: {
    headers: [
      "Player",
      {
        type: "image",
        src: "/assets/images/svg/yellow_card.svg",
        width: 11,
        height: 15,
      },
      {
        type: "image",
        src: "/assets/images/svg/multi_card.svg",
        width: 14,
        height: 18,
      },
      {
        type: "image",
        src: "/assets/images/svg/red_card.svg",
        width: 11,
        height: 15,
      },
    ],
    legend: [
      {
        type: "image",
        src: "/assets/images/svg/yellow_card.svg",
        fullForm: "Yellow Card",
      },
      {
        type: "image",
        src: "/assets/images/svg/multi_card.svg",
        fullForm: "Yellow & Red Card",
      },
      {
        type: "image",
        src: "/assets/images/svg/red_card.svg",
        fullForm: "Red Card",
      },
    ],
    dataKey: "cards",
    className: "ft_player_card",
    getRowData: (item) => [item?.yc, item?.syc, item?.rc],
  },
};

const FootballPlyarStats = ({
  data,
  active,
  websiteBaseUrl,
  dataPath,
  dataClient,
  sport = "football",
}) => {
  const baseURL = process.env.REACT_APP_BASE_URL;

  const config = STATS_CONFIG[active] || STATS_CONFIG.cards;
  const items = data?.[config.dataKey];

  const renderHeader = (header, index) => {
    if (typeof header === "string") {
      return <th key={index}>{header}</th>;
    }
    if (header.type === "image") {
      return (
        <th key={index}>
          <div className="flg">
            <NextImage
              src={`${baseURL}/public${header.src}`}
              width={header.width}
              height={header.height}
              alt="card"
            />
          </div>
        </th>
      );
    }
    return null;
  };

  const renderLegendItem = (item, index) => {
    if (item.type === "image") {
      return (
        <li key={index}>
          <span className="symbol">
            <NextImage
              src={`${baseURL}/public${item.src}`}
              width={11}
              height={15}
              alt="card"
            />
          </span>
          <span className="full_form">{item.fullForm}</span>
        </li>
      );
    }
    return (
      <li key={index}>
        <span className="symbol">{item.symbol}</span>
        <span className="full_form">{item.fullForm}</span>
      </li>
    );
  };

  if (!items?.length) {
    return <NoDataFound />;
  }

  return (
    <div className={`global_table striped ${config.className}`}>
      <table>
        <thead>
          <tr>{config.headers.map(renderHeader)}</tr>
        </thead>
        <tbody>
          {items.slice(0, 20).map((item, index) => (
            <tr key={item?.id || index}>
              <td>
                <div className="player_inf">
                  <div className="ply_des">
                    <a
                      href={teamLeagueInfoUrl({
                        dataClient,
                        websiteBaseUrl,
                        dataPath,
                        category: "player",
                        sport,
                        name: titleToSlug(item?.pn),
                        id: item?.player_id,
                      })}
                    >
                      <span className="name">{item?.pn}</span>
                    </a>
                    {active === "scorers" && item?.dob && (
                      <span className="sub_name">Dob: {item?.dob}</span>
                    )}
                  </div>
                </div>
              </td>
              {config.getRowData(item).map((value, idx) => (
                <td key={idx}>{value}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
      <div className="bottom_tr">
        <ul className="item_list">{config.legend.map(renderLegendItem)}</ul>
      </div>
    </div>
  );
};

export default FootballPlyarStats;
